var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFeatureSub6(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 88,
    height: 88,
    viewBox: "0 0 88 88",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 164156",
    transform: "translate(-1640 -6289)"
  }, /*#__PURE__*/React.createElement("circle", {
    "data-name": "\\uD0C0\\uC6D0 9448",
    cx: 44,
    cy: 44,
    r: 44,
    transform: "translate(1640 6289)",
    style: {
      opacity: 0.14
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.3 38.3h25.4a1.54 1.54 0 0 0 1.6-1.6V19.3l-9.6-9.6H11.3a1.54 1.54 0 0 0-1.6 1.6v25.4a1.54 1.54 0 0 0 1.6 1.6zm0 1.1a2.732 2.732 0 0 1-2.7-2.7V11.3a2.732 2.732 0 0 1 2.7-2.7h17.85L39.4 18.85V36.7a2.732 2.732 0 0 1-2.7 2.7zm4-8.15h17.4v-1.1H15.3zm0-6.7h17.4v-1.1H15.3zm0-6.7h10.65v-1.1H15.3zM9.7 38.3z",
    transform: "translate(1660.4 6309.4)",
    style: {
      fill: "#fff"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeatureSub6);
export default __webpack_public_path__ + "static/media/feature-sub-6.2d3e414f11df2f61136e092fc45c2c37.svg";
export { ForwardRef as ReactComponent };